<style>
      .wide_button_text {
    color: black;
    font-size: 16px;
    text-align: center;
    margin-top: 17px;
  }

  .wide_button {
    width: 100%;
    height: 50px;
    background-color: white;
    justify-content: center;
    align-items: center;
    display: flex;
    cursor: pointer;
    color: black
  }

    .disabled_red {
    width: 100%;
    height: 50px;
    background-color: black;
    outline: 1px solid #fe0007;
    justify-content: center;
    align-items: center;
    display: flex;
    cursor: pointer;
  }

  .disabled_red > .wide_button_text {
    color: #fe0007 !important;
    font-size: 16px;
    text-align: center;
    margin-top: 17px;
    opacity: 0.7;
  }

   .disabled_black {
    background-color: black !important;
    color: white !important;
    opacity: 0.7;
    border: 1px solid white !important;
  }

  .disabled_black > .wide_button_text {
    color: white !important;
  }
</style>

<script>
    export let onClick;
    export let isDisabled_BLACK;
    export let isDisabled_RED
    export let text;
    export let disabledText;

    $: isDisabled = isDisabled_RED || isDisabled_BLACK;
    $: disabledStyle = isDisabled_BLACK ? 'disabled_black' : isDisabled_RED ? 'disabled_red' : ''
    $: disabledTextStyle = isDisabled_BLACK ? 'disabled_black' : isDisabled_RED ? 'disabled_red' : ''
</script>

    <div
      on:click={isDisabled ? () => {} : onClick}
      class="wide_button {disabledStyle}"
    >
      <p class="wide_button_text  ">{isDisabled && disabledText ? disabledText : text}</p>
    </div>